// import { useState } from 'react';
// import { useAdmin, Associate } from '../../contexts/AdminContext';
// import { Pencil, Trash, Plus, Search, Mail, Phone, FileText } from 'lucide-react';
// import { toast } from 'sonner';

// export const AssociateMaster = () => {
//   const { associates, projects, addAssociate, updateAssociate, deleteAssociate } = useAdmin();
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [editingAssociate, setEditingAssociate] = useState<Associate | null>(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     mobile: '',
//     projectId: '',
//     aadharKyc: null as File | null,
//   });

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!formData.name || !formData.email || !formData.mobile || !formData.projectId) {
//       toast.error('Please fill all required fields');
//       return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       toast.error('Please enter a valid email address');
//       return;
//     }

//     const mobileRegex = /^[0-9]{10}$/;
//     if (!mobileRegex.test(formData.mobile)) {
//       toast.error('Please enter a valid 10-digit mobile number');
//       return;
//     }

//     const associateData = {
//       name: formData.name,
//       email: formData.email,
//       mobile: formData.mobile,
//       projectId: formData.projectId,
//       aadharKyc: formData.aadharKyc || undefined,
//     };

//     if (editingAssociate) {
//       updateAssociate(editingAssociate.id, associateData);
//       toast.success('Associate updated successfully');
//     } else {
//       addAssociate(associateData);
//       toast.success('Associate created successfully');
//     }

//     resetForm();
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       email: '',
//       mobile: '',
//       projectId: '',
//       aadharKyc: null,
//     });
//     setEditingAssociate(null);
//     setIsFormOpen(false);
//   };

//   const handleEdit = (associate: Associate) => {
//     setEditingAssociate(associate);
//     setFormData({
//       name: associate.name,
//       email: associate.email,
//       mobile: associate.mobile,
//       projectId: associate.projectId,
//       aadharKyc: null,
//     });
//     setIsFormOpen(true);
//   };

//   const handleDelete = (id: string) => {
//     if (confirm('Are you sure you want to delete this associate?')) {
//       deleteAssociate(id);
//       toast.success('Associate deleted successfully');
//     }
//   };

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       setFormData({ ...formData, aadharKyc: files[0] });
//     }
//   };

//   const filteredAssociates = associates.filter(associate =>
//     associate.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     associate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     associate.mobile.includes(searchTerm)
//   );

//   const getProjectName = (projectId: string) => {
//     const project = projects.find(p => p.id === projectId);
//     return project ? project.name : projectId;
//   };

//   return (
//     <div className="p-6">
//       <div className="mb-6">
//         <h1 className="text-2xl font-bold text-[#0B1C3D] mb-2">Associate Master</h1>
//         <p className="text-gray-600">Manage associates and their project allocations</p>
//       </div>

//       {/* Actions Bar */}
//       <div className="flex items-center justify-between mb-6 gap-4">
//         <div className="relative flex-1 max-w-md">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
//           <input
//             type="text"
//             placeholder="Search associates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//           />
//         </div>
//         <button
//           onClick={() => setIsFormOpen(true)}
//           className="flex items-center gap-2 bg-[#0B1C3D] text-white px-4 py-2 rounded-lg hover:bg-[#0B1C3D]/90 transition-colors"
//         >
//           <Plus size={20} />
//           Add Associate
//         </button>
//       </div>

//       {/* Creation Form */}
//       {isFormOpen && (
//         <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6 shadow-sm">
//           <h2 className="text-xl font-semibold mb-4 text-[#0B1C3D]">
//             {editingAssociate ? 'Edit Associate' : 'Create New Associate'}
//           </h2>
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//               <div>
//                 <label className="block text-sm font-medium mb-2 text-gray-700">
//                   Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                   placeholder="e.g., Jane Smith"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2 text-gray-700">
//                   Email <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="email"
//                   value={formData.email}
//                   onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                   placeholder="jane@example.com"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2 text-gray-700">
//                   Mobile Number <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   value={formData.mobile}
//                   onChange={(e) => setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
//                   placeholder="6309824545"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2 text-gray-700">
//                   Project Allocation <span className="text-red-500">*</span>
//                 </label>
//                 <select
//                   value={formData.projectId}
//                   onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//                   required
//                 >
//                   <option value="">Select Project</option>
//                   {projects.map(project => (
//                     <option key={project.id} value={project.id}>
//                       {project.name} - {project.area}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium mb-2 text-gray-700">
//                   Aadhar KYC Document
//                 </label>
//                 <input
//                   type="file"
//                   onChange={handleFileChange}
//                   accept=".pdf,image/*"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
//                 />
//                 {formData.aadharKyc && (
//                   <p className="text-xs text-green-600 mt-1">{formData.aadharKyc.name}</p>
//                 )}
//               </div>
//             </div>

//             <div className="flex gap-3">
//               <button
//                 type="submit"
//                 className="bg-[#D4AF37] text-white px-6 py-2 rounded-lg hover:bg-[#D4AF37]/90 transition-colors"
//               >
//                 {editingAssociate ? 'Update Associate' : 'Create Associate'}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-300 transition-colors"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Associates Table */}
//       <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto shadow-sm">
//         <table className="w-full">
//           <thead className="bg-[#0B1C3D] text-white">
//             <tr>
//               <th className="px-6 py-3 text-left">Name</th>
//               <th className="px-6 py-3 text-left">Email</th>
//               <th className="px-6 py-3 text-left">Mobile</th>
//               <th className="px-6 py-3 text-left">Project Assigned</th>
//               <th className="px-6 py-3 text-left">Aadhar KYC</th>
//               <th className="px-6 py-3 text-right">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredAssociates.length === 0 ? (
//               <tr>
//                 <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
//                   {searchTerm ? 'No associates found matching your search' : 'No associates created yet. Click "Add Associate" to get started.'}
//                 </td>
//               </tr>
//             ) : (
//               filteredAssociates.map((associate, index) => (
//                 <tr
//                   key={associate.id}
//                   className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors`}
//                 >
//                   <td className="px-6 py-4 font-medium text-gray-900">{associate.name}</td>
//                   <td className="px-6 py-4 text-gray-700">
//                     <div className="flex items-center gap-2">
//                       <Mail size={16} className="text-gray-400" />
//                       {associate.email}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 text-gray-700">
//                     <div className="flex items-center gap-2">
//                       <Phone size={16} className="text-gray-400" />
//                       {associate.mobile}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">
//                     <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800">
//                       {getProjectName(associate.projectId)}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4">
//                     {associate.aadharKyc ? (
//                       <FileText size={20} className="text-green-600" />
//                     ) : (
//                       <span className="text-gray-400 text-sm">N/A</span>
//                     )}
//                   </td>
//                   <td className="px-6 py-4">
//                     <div className="flex items-center justify-end gap-2">
//                       <button
//                         onClick={() => handleEdit(associate)}
//                         className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-colors"
//                         title="Edit"
//                       >
//                         <Pencil size={18} />
//                       </button>
//                       <button
//                         onClick={() => handleDelete(associate.id)}
//                         className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-colors"
//                         title="Delete"
//                       >
//                         <Trash size={18} />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Stats */}
//       <div className="mt-4 text-sm text-gray-600">
//         Total Associates: {filteredAssociates.length}
//         {searchTerm && ` (filtered from ${associates.length})`}
//       </div>
//     </div>
//   );
// };



// import React, { useEffect, useState } from 'react';
// import { Pencil, Trash, Plus, Search, Mail, Phone, FileText, Eye } from 'lucide-react';
// import { useAdmin } from '../AdminLayout/AdminProvider';
// import axios from 'axios';

// import { State, City } from "country-state-city";

// const API_BASE = "https://api.propertygalleria.in/master/api";

// const API_BASEE = "http://localhost:4001";


// export const AssociateMaster = () => {
//   const { associates, projects, addAssociate, updateAssociate, deleteAssociate, fetchAssociates, projectHeads } = useAdmin();
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [editingAssociate, setEditingAssociate] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [aadharVerified, setAadharVerified] = useState(false);
//   const [loadingOtp, setLoadingOtp] = useState(false);
//   console.log('this projectHeads', projectHeads)
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     mobile: '',
//     projectId: '',
//     aadharKyc: null,
//     experience_years: '',
//     designation: "",
//   });


//   const sendAadharOtp = async () => {
//     if (formData.aadharKyc.length !== 12) {
//       alert("Enter valid 12-digit Aadhaar number");
//       return;
//     }

//     try {
//       setLoadingOtp(true);
//       await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
//         Aadhar_No: formData.aadharKyc,
//       });
//       setOtpSent(true);
//       alert("OTP sent successfully");
//     } catch (err) {
//       alert("Failed to send OTP");
//     } finally {
//       setLoadingOtp(false);
//     }
//   };



//   const verifyAadharOtp = async () => {
//     if (!otp) {
//       alert("Enter OTP");
//       return;
//     }

//     try {
//       await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
//         otp,
//         Aadhar_No: formData.aadharKyc,
//       });

//       setAadharVerified(true);
//       alert("Aadhaar verified successfully");
//     } catch (err) {
//       alert("OTP verification failed");
//     }
//   };
//   // const getProjectName = (projectId) => {
//   //   console.log('this is projectIdoo',projectId)
//   //   const id = Number(projectId); // 👈 CRITICAL
//   //   const project = projects.find(p => p.id === id);
//   //   return project ? project.title : "";
//   // };

//   const getProjectName = (projectId) => {
//     const id = Number(projectId);
//     const project = projects.find(p => p.id === id);
//     return project ? project.title : "Not Assign ";
//   };



//   const handleSubmit = (e) => {
//     e.preventDefault();

//     //     if (!aadharVerified) {
//     //   alert("Please verify Aadhaar before submitting");
//     //   return;
//     // }


//     if (!formData.name || !formData.email || !formData.mobile) {
//       alert('Please fill all required fields');
//       return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       alert('Please enter a valid email address');
//       return;
//     }

//     const mobileRegex = /^[0-9]{10}$/;
//     if (!mobileRegex.test(formData.mobile)) {
//       alert('Please enter a valid 10-digit mobile number');
//       return;
//     }

//     const selectedProject = projects.find(
//       (p) => p.id === Number(formData.projectId)
//     );

//     const associateData = {
//       role: "agent",
//       full_name: formData.name,
//       email: formData.email,
//       mobile_number: formData.mobile,

//       aadhaar_number: formData.aadharKyc || undefined,

//       aadhaar_verified: "1",
//       experience_years: formData.experience_years,         // or from input if you add it
//       // project_name: formData.projectId,
//       project_name: Number(formData.projectId), // ✅ ID
//       reports_to_head_id: formData.reports_to_head_id,
//       state: formData.state,
//       city: formData.city,
//       profession: formData.profession,
//       designation: formData.designation,
//       //project_name: selectedProject?.project_name || "",
//       is_admin_approve: 1          // 👈 always 1
//     };

//     console.log('this is associateData', associateData)
//     if (editingAssociate) {

//       //updateAssociate(editingAssociate.associate_code, associateData);
//       updateAssociate(editingAssociate.user_id, associateData);

//       alert('Associate updated successfully');
//     } else {
//       addAssociate(associateData);
//       alert('Associate created successfully');
//     }

//     resetForm();
//   };

//   const resetForm1 = () => {
//     setFormData({
//       name: '',
//       email: '',
//       mobile: '',
//       projectId: '',
//       aadharKyc: null,
//     });
//     setEditingAssociate(null);
//     setIsFormOpen(false);
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       email: '',
//       mobile: '',
//       projectId: '',
//       aadharKyc: '',
//       experience_years: '',
//       reports_to_head_id: '',
//       state: '',
//       city: ''
//     });
//     setEditingAssociate(null);
//     setIsFormOpen(false);
//     setOtp('');
//     setOtpSent(false);
//     setAadharVerified(false);
//   };


//   // const handleEdit_old= (associate) => {
//   //   const project = projects.find(
//   //     (p) => p.project_name === associate.project_name
//   //   );
//   //   setEditingAssociate(associate);
//   //   setFormData({
//   //     name: associate.name,
//   //     email: associate.email,
//   //     mobile: associate.mobile,
//   //     projectId: project ? project.id : "",
//   //     aadharKyc: associate.aadhar_no,
//   //   });
//   //   setIsFormOpen(true);
//   // };


//   const handleEdit1 = (associate) => {
//     setEditingAssociate(associate);

//     setFormData({
//       name: associate.full_name,
//       email: associate.email,
//       mobile: associate.mobile_number,
//       projectId: projects.find(p => p.title === associate.project_name)?.id || "",
//       aadharKyc: associate.aadhaar_number,
//       experience_years: associate.experience_years,
//       reports_to_head_id: associate.reports_to_head_id
//     });

//     setIsFormOpen(true);
//   };


//   const handleEdit = (associate) => {
//     // ✅ RESET FIRST (important)
//     setFormData({
//       name: '',
//       email: '',
//       mobile: '',
//       projectId: '',
//       aadharKyc: '',
//       experience_years: '',
//       reports_to_head_id: '',
//       state: '',
//       city: '',
//     });

//     // ✅ SET EDIT MODE
//     setEditingAssociate(associate);

//     // ✅ SET DATA FROM CLICKED ROW
//     setFormData({
//       name: associate.full_name || '',
//       email: associate.email || '',
//       mobile: associate.mobile_number || '',
//       projectId: associate.project_name ? String(associate.project_name) : '',
//       aadharKyc: associate.aadhaar_number || '',
//       experience_years: associate.experience_years || '',
//       reports_to_head_id: associate.reports_to_head_id || '',
//       state: associate.state || '',
//       city: associate.city || '',
//     });

//     setIsFormOpen(true);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm('Are you sure you want to delete this associate?')) {
//       deleteAssociate(id);
//       alert('Associate deleted successfully');
//     }
//   };

//   const handleFileChange = (e) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       setFormData({ ...formData, aadharKyc: files[0] });
//     }
//   };
//   console.log('this is associates', associates)
//   const filteredAssociates = associates.filter(
//     (associate) =>
//       associate.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       associate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       associate.mobile_number.includes(searchTerm)
//   );

//   const getProjectNamee = (projectId) => {
//     const id = Number(projectId); // convert string to number
//     const project = projects.find((p) => p.id === id);
//     return project ? project.project_name : projectId;
//   };

//   // Inline Styles
//   const styles = {
//     container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
//     header: { marginBottom: '24px' },
//     title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
//     subtitle: { color: '#6B7280' },
//     actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
//     searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
//     searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
//     searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
//     addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//     formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
//     formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
//     inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
//     label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
//     required: { color: '#EF4444' },
//     input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
//     buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
//     buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//     tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
//     table: { width: '100%', borderCollapse: 'collapse' },
//     th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
//     td: { padding: '12px', color: '#374151', textAlign: 'center' },
//     badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
//     actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
//     stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },
//   };


//   const [checkedUsers, setCheckedUsers] = useState([]);

//   const toggleCheckbox = (userId) => {
//     setCheckedUsers((prev) => {
//       if (prev.includes(userId)) {
//         return prev.filter((id) => id !== userId);
//       } else {
//         return [...prev, userId];
//       }
//     });
//   };

//   const handleSubmitApprove = async () => {
//     try {
//       // Approve all selected users
//       await Promise.all(
//         checkedUsers.map((userId) =>
//           axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
//         )
//       );

//       alert("Selected users approved successfully!");


//       setCheckedUsers([]);
//       fetchAssociates();
//       // Optional: refresh list here
//     } catch (error) {
//       console.error(error);
//       alert("Approval failed. Please try again.");
//     }
//   };


//   const [users, setUsers] = useState([]);

//   useEffect(() => {


//     fetch("https://api.propertygalleria.in/master/api/get/users")
//       .then(res => res.json())
//       .then(data => setUsers(data));
//   }, []);



//   const getProjectHeadName = (headUserId) => {
//     if (!headUserId) return "Not Assign ";

//     const head = projectHeads.find(
//       (ph) => Number(ph.user_id) === Number(headUserId)
//     );

//     return head ? head.full_name : "Not Assign ";
//   };


//   const states = State.getStatesOfCountry("IN");


//   const [agentDesc, setAgentDesc] = useState([]);



//   const fetchPropertyOwners = async () => {
//     try {
//       const res = await axios.get(`https://api.propertygalleria.in/master/api/get/agentdesignation`);
//       setAgentDesc(res.data);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to fetch property owners");
//     }
//   };

//   useEffect(() => {
//     fetchPropertyOwners();
//   }, []);


//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm]);

//   const totalPages = Math.ceil(filteredAssociates.length / itemsPerPage);

//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedLeads = filteredAssociates.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );
//   console.log('this is paginatedLeads', paginatedLeads)

//   return (
//     <div style={styles.container}>
//       {/* Header */}
//       <div style={styles.header}>
//         <h1 style={styles.title}>Associate Master</h1>
//         <p style={styles.subtitle}>Manage associates and their project allocations</p>
//       </div>

//       {/* Actions Bar */}
//       <div style={styles.actionsBar}>
//         <div style={styles.searchWrapper}>
//           <Search size={20} style={styles.searchIcon} />
//           <input
//             type="text"
//             placeholder="Search associates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={styles.searchInput}
//           />
//         </div>
//         <button style={styles.addButton} onClick={() => setIsFormOpen(true)}>
//           <Plus size={20} /> Add Associate
//         </button>
//       </div>

//       {/* Form */}
//       {isFormOpen && (
//         <div style={styles.formContainer}>
//           <h2 style={styles.formTitle}>{editingAssociate ? 'Edit Associate' : 'Create New Associate'}</h2>
//           <form onSubmit={handleSubmit}>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
//               {editingAssociate && (
//                 <div>
//                   <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Project Allocation *</label>
//                   <select
//                     value={formData.projectId}
//                     onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
//                     style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
//                   //  required
//                   >
//                     <option value="">Select Property</option>
//                     {projects.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.title} - {project.location}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//               {/* <div>
//                 <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Property Head Allocation *</label>
//                 <select
//                   value={formData.reports_to_head_id}
//                   onChange={(e) => setFormData({ ...formData, reports_to_head_id: e.target.value })}
//                   style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
//                   required
//                 >
//                   <option value="">Select Property Head</option>
//                   {/* {associates.map((agent) => (
//                                         <option key={agent.id} value={agent.id}>
//                                             {agent.full_name}
//                                         </option>
//                                     ))} *

//                   {users
//                     .filter(u => u.role === "projectHead")
//                     .map(agent => (
//                       <option key={agent.id} value={agent.id}>
//                         {agent.full_name}
//                       </option>
//                     ))}
//                 </select>
//               </div> */}


//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Name <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                   placeholder="e.g., Jane Smith"
//                   style={styles.input}
//                   required
//                 />
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Email <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="email"
//                   value={formData.email}
//                   onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                   placeholder="jane@example.com"
//                   style={styles.input}
//                   required
//                 />
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Mobile Number <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   value={formData.mobile}
//                   onChange={(e) => setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
//                   placeholder="6309824545"
//                   style={styles.input}
//                   required
//                 />
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Years of Experience <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="number"
//                   value={formData.experience_years}
//                   onChange={(e) => setFormData({ ...formData, experience_years: e.target.value })}
//                   placeholder="Enter you Experience"
//                   style={styles.input}
//                   required
//                 />
//               </div>


//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Profession <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="profession"
//                   value={formData.profession}
//                   onChange={(e) => setFormData({ ...formData, profession: e.target.value })}
//                   placeholder="Enter your Profession"
//                   style={styles.input}
//                   required
//                 />
//               </div>

//               <div>
//                 <label style={styles.label}>Designations *</label>
//                 <select
//                   value={formData.designation}
//                   onChange={(e) =>
//                     setFormData({ ...formData, designation: e.target.value })
//                   }
//                   style={styles.input}
//                   required
//                 >
//                   <option value="">Select Owner</option>
//                   {agentDesc.map((owner) => (
//                     <option key={owner.id} value={owner.designation}>
//                       {owner.designation}
//                     </option>
//                   ))}
//                 </select>
//               </div>



//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>State</label>
//                 <select
//                   style={styles.input}
//                   value={formData.state}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       state: e.target.value,
//                       city: "" // reset city when state changes
//                     })
//                   }
//                   required
//                 >
//                   <option value="">Select State</option>
//                   {states.map((state) => (
//                     <option key={state.isoCode} value={state.isoCode}>
//                       {state.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>City</label>
//                 <select
//                   style={styles.input}
//                   value={formData.city}
//                   onChange={(e) =>
//                     setFormData({ ...formData, city: e.target.value })
//                   }
//                   required
//                   disabled={!formData.state}
//                 >
//                   <option value="">Select City</option>
//                   {City.getCitiesOfState("IN", formData.state).map((city) => (
//                     <option key={city.name} value={city.name}>
//                       {city.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Aadhaar Number <span style={styles.required}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.aadharKyc}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       aadharKyc: e.target.value.replace(/\D/g, "").slice(0, 12),
//                     })
//                   }
//                   placeholder="Enter 12-digit Aadhaar"
//                   style={styles.input}
//                   maxLength={12}
//                 />
//               </div>
//               <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                 <button
//                   type="button"
//                   onClick={sendAadharOtp}
//                   disabled={loadingOtp || otpSent}
//                   style={styles.buttonSecondary}
//                 >
//                   {loadingOtp ? "Sending..." : otpSent ? "OTP Sent" : "Send OTP"}
//                 </button>

//                 {aadharVerified && (
//                   <span style={{ ...styles.badge, backgroundColor: "#16A34A" }}>
//                     Verified
//                   </span>
//                 )}
//               </div>

//               {otpSent && !aadharVerified && (
//                 <div style={{ marginTop: 8 }}>
//                   <input
//                     type="text"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                     placeholder="Enter OTP"
//                     style={styles.input}
//                   />
//                   <button
//                     type="button"
//                     onClick={verifyAadharOtp}
//                     style={{ ...styles.buttonPrimary, marginTop: 8 }}
//                   >
//                     Verify OTP
//                   </button>
//                 </div>
//               )}

//             </div>

//             <div style={{ display: 'flex', gap: '12px' }}>
//               <button type="submit" style={styles.buttonPrimary}>
//                 {editingAssociate ? 'Update Associate' : 'Create Associate'}
//               </button>
//               <button type="button" onClick={resetForm} style={styles.buttonSecondary}>
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Associates Table */}
//       <div style={styles.tableContainer}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Associate Code</th>
//               <th style={styles.th}>Name</th>
//               <th style={styles.th}>Email</th>
//               <th style={styles.th}>Mobile</th>
//               <th style={styles.th}>Project Assigned</th>
//               {/* <th style={styles.th}>Aadhar KYC</th> */}
//               {/* <th style={styles.th}>Project Head </th> */}
//               <th style={styles.th}>Actions</th>
//               <th style={styles.th}>Approve </th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedLeads.length === 0 ? (
//               <tr>
//                 <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#9CA3AF' }}>
//                   {searchTerm
//                     ? 'No associates found matching your search'
//                     : 'No associates created yet. Click "Add Associate" to get started.'}
//                 </td>
//               </tr>
//             ) : (
//               paginatedLeads.map((associate, index) => (
//                 <tr
//                  // key={associate.user_id}
//                   key={`${associate.id}${associate.user_id}-${associate.reports_to_head_id}`}


//                   style={{
//                     backgroundColor: index % 2 === 0 ? 'white' : '#F9FAFB',
//                     transition: 'background-color 0.2s',
//                   }}
//                 >
//                   <td style={styles.td}>
//                     {associate.custom_id}
//                   </td>
//                   <td style={styles.td}>{associate.full_name}</td>
//                   <td style={styles.td}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                       <Mail size={16} color="#9CA3AF" />
//                       {associate.email}
//                     </div>
//                   </td>
//                   <td style={styles.td}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                       <Phone size={16} color="#9CA3AF" />
//                       {associate.mobile_number}
//                     </div>
//                   </td>
//                   <td style={styles.td}>
//                     <span style={styles.badge}>{getProjectName(associate.project_name)}</span>
//                   </td>
//                   {/* <td style={styles.td}>
//                     {associate.aadhaar_number ? associate.aadhaar_number : <span style={{ color: '#9CA3AF', fontSize: '12px' }}>N/A</span>}
//                   </td> */}
//                   {/* <td style={styles.td}>
//                     <span style={styles.badge}>{associate.reports_to_head_id}</span>
//                   </td> */}

//                   {/* <td style={styles.td}>
//                     <span style={styles.badge}>
//                       {getProjectHeadName(associate.reports_to_head_id)}
//                     </span>
//                   </td> */}

//                   <td style={styles.td}>
//                     <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
//                       {/* <button
//                         // onClick={() => openViewModal(associate)}
//                         style={{ ...styles.actionButton, color: '#8b306d' }}
//                         title="View"
//                       >
//                         <Eye size={18} />
//                       </button> */}
//                       <button onClick={() => handleEdit(associate)} style={{ ...styles.actionButton, color: '#8b306d' }} title="Edit">
//                         <Pencil size={18} />
//                       </button>
//                       <button onClick={() => handleDelete(associate.user_id)} style={{ ...styles.actionButton, color: '#42987e' }} title="Delete">
//                         <Trash size={18} />
//                       </button>
//                     </div>
//                   </td>
//                   {/* <td style={styles.td}>{associate.is_admin_approve}</td> */}
//                   <td style={styles.td}>
//                     <input
//                       type="checkbox"
//                       checked={
//                         associate.is_admin_approve === 1
//                           ? true
//                           : checkedUsers.includes(associate.user_id)
//                       }
//                       // disabled={associate.is_admin_approve === 1}
//                       onChange={() => toggleCheckbox(associate.user_id)}
//                     />
//                   </td>

//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>

//         {/* ✅ Show Submit Button only if at least 1 checked */}
//         {checkedUsers.length > 0 && (
//           <div style={{ marginTop: "16px", textAlign: "right" }}>
//             <button onClick={handleSubmitApprove} style={styles.submitButton}>
//               Approve the User
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Stats */}
//       <div style={styles.stats}>
//         Total Associates: {filteredAssociates.length}
//         {searchTerm && ` (filtered from ${associates.length})`}
//       </div>



//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "12px 16px",
//           borderTop: "1px solid #E5E7EB",
//           background: "#F9FAFB",
//         }}
//       >
//         <div style={{ fontSize: 14, color: "#6B7280" }}>
//           Showing {startIndex + 1}–
//           {Math.min(startIndex + itemsPerPage, filteredAssociates.length)} of{" "}
//           {filteredAssociates.length}
//         </div>

//         <div style={{ display: "flex", gap: "6px" }}>
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((p) => p - 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               background: currentPage === 1 ? "#eee" : "#fff",
//               cursor: "pointer",
//             }}
//           >
//             Prev
//           </button>

//           {Array.from({ length: totalPages }, (_, i) => i + 1)
//             .slice(
//               Math.max(0, currentPage - 3),
//               Math.min(totalPages, currentPage + 2)
//             )
//             .map((page) => (
//               <button
//                 key={page}
//                 onClick={() => setCurrentPage(page)}
//                 style={{
//                   padding: "6px 12px",
//                   borderRadius: "6px",
//                   border: "1px solid #ddd",
//                   background:
//                     currentPage === page ? "#8b306d" : "#fff",
//                   color: currentPage === page ? "#fff" : "#333",
//                   cursor: "pointer",
//                 }}
//               >
//                 {page}
//               </button>
//             ))}

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//             style={{
//               padding: "6px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               background:
//                 currentPage === totalPages ? "#eee" : "#fff",
//               cursor: "pointer",
//             }}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//     </div>
//   );
// };





import React, { useEffect, useState } from 'react';
import { Pencil, Trash, Plus, Search, Mail, Phone, FileText, Eye } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';
import axios from 'axios';

import { State, City } from "country-state-city";

const API_BASE = "https://api.propertygalleria.in/master/api";

const API_BASEE = "http://localhost:4001";


export const AssociateMaster = () => {
  const { associates, projects, addAssociate, updateAssociate, deleteAssociate, fetchAssociates, projectHeads } = useAdmin();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingAssociate, setEditingAssociate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [aadharVerified, setAadharVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);


  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);


  console.log('this projectHeads', projectHeads)
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   mobile: '',
  //   projectId: '',
  //   aadharKyc: null,
  //   experience_years: '',
  //   designation: "",
  // });


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    projectId: '',
    aadharKyc: '',
    experience_years: '',
    designation: "",
    profession: '',
    state: '',
    city: '',
    reports_to_head_id: '',
    referred_by: '',
    refer_type: '',
  });

  const sendAadharOtp = async () => {
    if (formData.aadharKyc.length !== 12) {
      alert("Enter valid 12-digit Aadhaar number");
      return;
    }

    try {
      setLoadingOtp(true);
      await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
        Aadhar_No: formData.aadharKyc,
      });
      setOtpSent(true);
      alert("OTP sent successfully");
    } catch (err) {
      alert("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };



  const verifyAadharOtp = async () => {
    if (!otp) {
      alert("Enter OTP");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
        otp,
        Aadhar_No: formData.aadharKyc,
      });

      setAadharVerified(true);
      alert("Aadhaar verified successfully");
    } catch (err) {
      alert("OTP verification failed");
    }
  };

  const getProjectName = (projectId) => {
    const id = Number(projectId);
    const project = projects.find(p => p.id === id);
    return project ? project.title : "Not Assign ";
  };


  const [referralType, setReferralType] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();


    if (!formData.name || !formData.email || !formData.mobile) {
      alert('Please fill all required fields');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    const selectedProject = projects.find(
      (p) => p.id === Number(formData.projectId)
    );

    // const associateData = {
    //   role: "agent",
    //   full_name: formData.name,
    //   email: formData.email,
    //   mobile_number: formData.mobile,

    //   aadhaar_number: formData.aadharKyc || undefined,

    //   aadhaar_verified: "1",
    //   experience_years: formData.experience_years,         // or from input if you add it
    //   // project_name: formData.projectId,
    //   project_name: Number(formData.projectId), // ✅ ID
    //   reports_to_head_id: formData.reports_to_head_id,
    //   state: formData.state,
    //   city: formData.city,
    //   profession: formData.profession,
    //   designation: formData.designation,
    //   //project_name: selectedProject?.project_name || "",
    //   is_admin_approve: 1          // 👈 always 1
    // };


    const associateData = {
      role: "agent",
      full_name: formData.name,
      email: formData.email,
      mobile_number: formData.mobile,
      aadhaar_number: formData.aadharKyc || undefined,
      aadhaar_verified: "1",
      experience_years: formData.experience_years,
      project_name: Number(formData.projectId),
      reports_to_head_id: formData.reports_to_head_id,
      state: formData.state,
      city: formData.city,
      profession: formData.profession,
      designation: formData.designation,

        referred_by: formData.referred_by,
      

      is_admin_approve: 1
    };

    console.log('this is associateData', associateData)
    if (editingAssociate) {

      //updateAssociate(editingAssociate.associate_code, associateData);
      updateAssociate(editingAssociate.user_id, associateData);

      alert('Associate updated successfully');
    } else {
      addAssociate(associateData);
      alert('Associate created successfully');
    }

    resetForm();
  };


  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      mobile: '',
      projectId: '',
      aadharKyc: '',
      experience_years: '',
      reports_to_head_id: '',
      state: '',
      city: '',
      referred_by: '',
      refer_type: '',
    });
    setEditingAssociate(null);
    setIsFormOpen(false);
    setOtp('');
    setOtpSent(false);
    setAadharVerified(false);

    setInvestorReferType('');
    setReferredCode('');
    setReferredName('');
  };


  // const handleEdit = (associate) => {
  //   // ✅ RESET FIRST (important)
  //   setFormData({
  //     name: '',
  //     email: '',
  //     mobile: '',
  //     projectId: '',
  //     aadharKyc: '',
  //     experience_years: '',
  //     reports_to_head_id: '',
  //     state: '',
  //     city: '',
  //   });

  //   // ✅ SET EDIT MODE
  //   setEditingAssociate(associate);

  //   // ✅ SET DATA FROM CLICKED ROW
  //   setFormData({
  //     name: associate.full_name || '',
  //     email: associate.email || '',
  //     mobile: associate.mobile_number || '',
  //     projectId: associate.project_name ? String(associate.project_name) : '',
  //     aadharKyc: associate.aadhaar_number || '',
  //     experience_years: associate.experience_years || '',
  //     reports_to_head_id: associate.reports_to_head_id || '',
  //     state: associate.state || '',
  //     city: associate.city || '',
  //   });

  //   setIsFormOpen(true);
  // };


  const handleEdit = (associate) => {

  // detect referral type
  const referralOptions = ["Friend", "Website", "Social Media"];

  let detectedReferralType = "";

  // if referred_by contains agent code
  if (
    associate.referred_by &&
    !referralOptions.includes(associate.referred_by)
  ) {
    detectedReferralType = "Referral Code";
  } else {
    detectedReferralType = associate.referred_by || "";
  }

  // set dropdown type
  setReferralType(detectedReferralType);

  // edit mode
  setEditingAssociate(associate);

  // set form data
  setFormData({
    name: associate.full_name || "",
    email: associate.email || "",
    mobile: associate.mobile_number || "",
    projectId: associate.project_name
      ? String(associate.project_name)
      : "",
    aadharKyc: associate.aadhaar_number || "",
    experience_years: associate.experience_years || "",
    reports_to_head_id: associate.reports_to_head_id || "",
    state: associate.state || "",
    city: associate.city || "",
    profession: associate.profession || "",
    designation: associate.designation || "",

    referred_by: associate.referred_by || "",
  });

  setIsFormOpen(true);
};


  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this associate?')) {
      deleteAssociate(id);
      alert('Associate deleted successfully');
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setFormData({ ...formData, aadharKyc: files[0] });
    }
  };
  console.log('this is associates', associates)
  const filteredAssociates = associates.filter(
    (associate) =>
      associate.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      associate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      associate.mobile_number.includes(searchTerm)
  );
  // Inline Styles
  const styles = {
    container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
    header: { marginBottom: '24px' },
    title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
    subtitle: { color: '#6B7280' },
    actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
    searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
    searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
    inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
    label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
    required: { color: '#EF4444' },
    input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
    buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
    td: { padding: '12px', color: '#374151', textAlign: 'center' },
    badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
    actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },
  };


  const [checkedUsers, setCheckedUsers] = useState([]);

  const toggleCheckbox = (userId) => {
    setCheckedUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  const handleSubmitApprove = async () => {
    try {
      // Approve all selected users
      await Promise.all(
        checkedUsers.map((userId) =>
          axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
        )
      );

      alert("Selected users approved successfully!");


      setCheckedUsers([]);
      fetchAssociates();
      // Optional: refresh list here
    } catch (error) {
      console.error(error);
      alert("Approval failed. Please try again.");
    }
  };


  const [users, setUsers] = useState([]);

  useEffect(() => {


    fetch("https://api.propertygalleria.in/master/api/get/users")
      .then(res => res.json())
      .then(data => setUsers(data));
  }, []);
  const states = State.getStatesOfCountry("IN");
  const [agentDesc, setAgentDesc] = useState([]);

  const fetchPropertyOwners = async () => {
    try {
      const res = await axios.get(`https://api.propertygalleria.in/master/api/get/agentdesignation`);
      setAgentDesc(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch property owners");
    }
  };

  useEffect(() => {
    fetchPropertyOwners();
  }, []);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredAssociates.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;

  // const paginatedLeads = filteredAssociates.slice(
  //   startIndex,
  //   startIndex + itemsPerPage
  // );

  const groupedAssociates = Object.values(
    filteredAssociates.reduce((acc, item) => {
      if (!acc[item.user_id]) {
        acc[item.user_id] = {
          ...item,
          projects: [],
        };
      }

      if (item.project_name) {
        acc[item.user_id].projects.push(item.project_name);
      }

      return acc;
    }, {})
  );

  const paginatedLeads = groupedAssociates.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  console.log('this is paginatedLeads', paginatedLeads)

  const openProjectsModal = (projects) => {
    setSelectedProjects(projects);
    setProjectModalOpen(true);
  };




  const [investorReferModal, setInvestorReferModal] = useState(false);
  const [investorReferType, setInvestorReferType] = useState("");

  const [referModalVisible, setReferModalVisible] = useState(false);
  const [referredCode, setReferredCode] = useState("");
  const [referredName, setReferredName] = useState("");

  const [referAgents, setReferAgents] = useState([]);

  // fetch agents
  const fetchAgents = async () => {
    try {
      const res = await axios.get(
        "https://api.propertygalleria.in/master/api/api/agents/referr"
      );

      setReferAgents(res.data.data);

    } catch (error) {
      console.log("Agent API error:", error);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);


  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>Associate Master</h1>
        <p style={styles.subtitle}>Manage associates and their project allocations</p>
      </div>

      {/* Actions Bar */}
      <div style={styles.actionsBar}>
        <div style={styles.searchWrapper}>
          <Search size={20} style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search associates..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        <button style={styles.addButton} onClick={() => setIsFormOpen(true)}>
          <Plus size={20} /> Add Associate
        </button>
      </div>

      {/* Form */}
      {isFormOpen && (
        <div style={styles.formContainer}>
          <h2 style={styles.formTitle}>{editingAssociate ? 'Edit Associate' : 'Create New Associate'}</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
              {editingAssociate && (
                <div>
                  <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Project Allocation *</label>
                  <select
                    value={formData.projectId}
                    onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
                    style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  //  required
                  >
                    <option value="">Select Property</option>
                    {projects.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.title} - {project.location}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Name <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g., Jane Smith"
                  style={styles.input}
                  
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Email <span style={styles.required}>*</span>
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="jane@example.com"
                  style={styles.input}
                  
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Mobile Number <span style={styles.required}>*</span>
                </label>
                <input
                  type="tel"
                  value={formData.mobile}
                  onChange={(e) => setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  placeholder="6309824545"
                  style={styles.input}
                  
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Years of Experience <span style={styles.required}>*</span>
                </label>
                <input
                  type="number"
                  value={formData.experience_years}
                  onChange={(e) => setFormData({ ...formData, experience_years: e.target.value })}
                  placeholder="Enter you Experience"
                  style={styles.input}
                  
                />
              </div>


              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Profession <span style={styles.required}>*</span>
                </label>
                <input
                  type="profession"
                  value={formData.profession}
                  onChange={(e) => setFormData({ ...formData, profession: e.target.value })}
                  placeholder="Enter your Profession"
                  style={styles.input}
                  
                />
              </div>

              <div>
                <label style={styles.label}>Designations *</label>
                <select
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  style={styles.input}
                  
                >
                  <option value="">Select Owner</option>
                  {agentDesc.map((owner) => (
                    <option key={owner.id} value={owner.designation}>
                      {owner.designation}
                    </option>
                  ))}
                </select>
              </div>



              <div style={styles.inputGroup}>
                <label style={styles.label}>State</label>
                <select
                  style={styles.input}
                  value={formData.state}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      state: e.target.value,
                      city: "" // reset city when state changes
                    })
                  }
                  
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>City</label>
                <select
                  style={styles.input}
                  value={formData.city}
                  onChange={(e) =>
                    setFormData({ ...formData, city: e.target.value })
                  }
                  
                  disabled={!formData.state}
                >
                  <option value="">Select City</option>
                  {City.getCitiesOfState("IN", formData.state).map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Aadhaar Number <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.aadharKyc}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      aadharKyc: e.target.value.replace(/\D/g, "").slice(0, 12),
                    })
                  }
                  placeholder="Enter 12-digit Aadhaar"
                  style={styles.input}
                  maxLength={12}
                />
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button
                  type="button"
                  onClick={sendAadharOtp}
                  disabled={loadingOtp || otpSent}
                  style={styles.buttonSecondary}
                >
                  {loadingOtp ? "Sending..." : otpSent ? "OTP Sent" : "Send OTP"}
                </button>

                {aadharVerified && (
                  <span style={{ ...styles.badge, backgroundColor: "#16A34A" }}>
                    Verified
                  </span>
                )}
              </div>

              {otpSent && !aadharVerified && (
                <div style={{ marginTop: 8 }}>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                    placeholder="Enter OTP"
                    style={styles.input}
                  />
                  <button
                    type="button"
                    onClick={verifyAadharOtp}
                    style={{ ...styles.buttonPrimary, marginTop: 8 }}
                  >
                    Verify OTP
                  </button>
                </div>
              )}


              {/* REFERRED BY */}

              {/* <div style={{ marginTop: '15px' }}>
                <label style={{ fontSize: "14px", fontWeight: "500", margin: '5px' }}>
                  Referred By
                </label>

                <span
                  style={styles.input}
                  onClick={() => setInvestorReferModal(true)}
                >
                  {investorReferType || "Select"}
                </span>
              </div> */}


              {/* REFER TYPE MODAL */}

              {/* {investorReferModal && (
                <div style={styles.modalOverlay}>

                  <div style={styles.modalBox}>

                    <h3>Select Referral Type</h3>

                    {["Referral Code", "Friend", "Website", "Social Media"].map(
                      (item) => (
                        <div
                          key={item}
                          style={styles.modalItem}
                          onClick={() => {
                            setInvestorReferType(item);
                            setFormData({
                              ...formData,
                              refer_type: item
                            });

                            setInvestorReferModal(false);
                          }}
                        >
                          {item}
                        </div>
                      )
                    )}

                    <button
                      style={styles.closeBtn}
                      onClick={() => setInvestorReferModal(false)}
                    >
                      Close
                    </button>

                  </div>
                </div>
              )}
 */}

              {/* AGENT SELECT */}
              {/* 
              {investorReferType === "Referral Code" && (
                <div style={{ marginTop: '15px' }}>

                  <label style={{ fontSize: "14px", fontWeight: "500" }}>
                    Select Agent
                  </label>

                  <span
                    style={styles.input}
                    onClick={() => setReferModalVisible(true)}
                  >
                    {referredName || "Select Agent"}
                  </span>

                </div>
              )} */}


              {/* AGENT MODAL */}

              {/* {referModalVisible && (
                <div style={styles.modalOverlay}>

                  <div style={styles.agentModal}>

                    <h3>Select Agent</h3>

                    <div style={styles.agentList}>

                      {referAgents.map((item) => {

                        const isSelected = referredCode === item.code_id;

                        return (
                          <div
                            key={item.code_id}
                            style={{
                              ...styles.agentItem,
                              background: isSelected ? "#2563eb" : "#fff",
                              color: isSelected ? "#fff" : "#000"
                            }}

                            // onClick={() => {
                            //   setReferredCode(item.code_id);
                            //   setReferredName(`${item.code_id} - ${item.name}`);
                            //   handleChange(item.code_id, "referred_by");
                            //   setReferModalVisible(false);
                            // }}
                            onClick={() => {
                              setReferredCode(item.code_id);

                              setReferredName(`${item.code_id} - ${item.name}`);

                              setFormData({
                                ...formData,
                                referred_by: item.code_id
                              });

                              setReferModalVisible(false);
                            }}
                          >
                            {item.code_id} - {item.name}
                          </div>
                        );
                      })}

                    </div>

                    <button
                      style={styles.closeBtn}
                      onClick={() => setReferModalVisible(false)}
                    >
                      Close
                    </button>

                  </div>
                </div>
              )} */}
              {/* REFERRED BY */}

              {/* <div style={styles.inputGroup}>
  <label style={styles.label}>
    Referred By
  </label>

  <select
    style={styles.input}
    value={formData.refer_type || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        refer_type: e.target.value,
        referred_by: "", // reset selected agent
      })
    }
  >
    <option value="">Select Referral Type</option>

    <option value="Referral Code">
      Referral Code
    </option>

    <option value="Friend">
      Friend
    </option>

    <option value="Website">
      Website
    </option>

    <option value="Social Media">
      Social Media
    </option>
  </select>
</div> */}


              {/* AGENT DROPDOWN */}

              {/* {formData.refer_type === "Referral Code" && (
  <div style={styles.inputGroup}>
    <label style={styles.label}>
      Select Agent
    </label>

    <select
      style={styles.input}
      value={formData.referred_by || ""}
      onChange={(e) =>
        setFormData({
          ...formData,
          referred_by: e.target.value,
        })
      }
    >
      <option value="">Select Agent</option>

      {referAgents.map((item) => (
        <option
          key={item.code_id}
          value={item.code_id}
        >
          {item.code_id} - {item.name}
        </option>
      ))}
    </select>
  </div>
)} */}

              {/* REFERRED BY */}

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Referred By
                </label>

                <select
                  style={styles.input}
                  value={referralType}
                  // disabled={editingAssociate}
                  onChange={(e) => {

                    const value = e.target.value;

                    setReferralType(value);

                    // if not referral code
                    // directly store text
                    if (value !== "Referral Code") {

                      setFormData({
                        ...formData,
                        referred_by: value
                      });

                    } else {

                      // clear previous value
                      setFormData({
                        ...formData,
                        referred_by: ""
                      });
                    }
                  }}
                >
                  <option value="">Select Referral Type</option>

                  <option value="Referral Code">
                    Referral Code
                  </option>

                  <option value="Friend">
                    Friend
                  </option>

                  <option value="Website">
                    Website
                  </option>

                  <option value="Social Media">
                    Social Media
                  </option>

                </select>
              </div>


              {/* AGENT DROPDOWN */}

              {referralType === "Referral Code" && (

                <div style={styles.inputGroup}>

                  <label style={styles.label}>
                    Select Agent
                  </label>

                  <select
                    style={styles.input}
                    value={formData.referred_by}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        referred_by: e.target.value
                      })
                    }
                  >
                    <option value="">
                      Select Agent
                    </option>

                    {referAgents.map((item) => (

                      <option
                        key={item.code_id}
                        value={item.code_id}
                      >
                        {item.code_id} - {item.name}
                      </option>

                    ))}

                  </select>

                </div>

              )}

            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="submit" style={styles.buttonPrimary}>
                {editingAssociate ? 'Update Associate' : 'Create Associate'}
              </button>
              <button type="button" onClick={resetForm} style={styles.buttonSecondary}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Associates Table */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Associate Code</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Mobile</th>
                <th style={styles.th}>Referred By</th> 
              <th style={styles.th}>Project Assigned</th>
            
               {/* <th style={styles.th}>Project Head </th> */}
              <th style={styles.th}>Actions</th>
              <th style={styles.th}>Approve </th>
            </tr>
          </thead>
          <tbody>
            {paginatedLeads.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#9CA3AF' }}>
                  {searchTerm
                    ? 'No associates found matching your search'
                    : 'No associates created yet. Click "Add Associate" to get started.'}
                </td>
              </tr>
            ) : (
              paginatedLeads.map((associate, index) => (
                <tr
                  // key={associate.user_id}
                  key={`${associate.id}${associate.user_id}-${associate.reports_to_head_id}`}


                  style={{
                    backgroundColor: index % 2 === 0 ? 'white' : '#F9FAFB',
                    transition: 'background-color 0.2s',
                  }}
                >
                  <td style={styles.td}>
                    {associate.custom_id}
                  </td>
                  <td style={styles.td}>{associate.full_name}</td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Mail size={16} color="#9CA3AF" />
                      {associate.email}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Phone size={16} color="#9CA3AF" />
                      {associate.mobile_number}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <span style={styles.badge}>{associate.referred_by}</span>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                      <span style={styles.badge}>
                        {associate.projects.length} Projects
                      </span>

                      <button
                        style={{ ...styles.actionButton, color: "#8b306d" }}
                        onClick={() => openProjectsModal(associate.projects)}
                      >
                        <Eye size={18} />
                      </button>
                    </div>
                  </td>

                  <td style={styles.td}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                      <button onClick={() => handleEdit(associate)} style={{ ...styles.actionButton, color: '#8b306d' }} title="Edit">
                        <Pencil size={18} />
                      </button>
                      <button onClick={() => handleDelete(associate.user_id)} style={{ ...styles.actionButton, color: '#42987e' }} title="Delete">
                        <Trash size={18} />
                      </button>
                    </div>
                  </td>
                  {/* <td style={styles.td}>{associate.is_admin_approve}</td> */}
                  <td style={styles.td}>
                    <input
                      type="checkbox"
                      checked={
                        associate.is_admin_approve === 1
                          ? true
                          : checkedUsers.includes(associate.user_id)
                      }
                      // disabled={associate.is_admin_approve === 1}
                      onChange={() => toggleCheckbox(associate.user_id)}
                    />
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>

        {projectModalOpen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
            onClick={() => setProjectModalOpen(false)}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#fff",
                padding: 20,
                borderRadius: 12,
                width: 500,
                maxHeight: "70%",
                overflowY: "auto",
              }}
            >
              <h3 style={{ color: "#8b306d" }}>Assigned Projects</h3>

              {selectedProjects.map((pid, i) => (
                <div
                  key={i}
                  style={{
                    padding: 10,
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {getProjectName(pid)}
                </div>
              ))}

              <button
                style={{
                  marginTop: 12,
                  padding: "8px 16px",
                  background: "#8b306d",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  cursor: "pointer",
                }}
                onClick={() => setProjectModalOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* ✅ Show Submit Button only if at least 1 checked */}
        {checkedUsers.length > 0 && (
          <div style={{ marginTop: "16px", textAlign: "right" }}>
            <button onClick={handleSubmitApprove} style={styles.submitButton}>
              Approve the User
            </button>
          </div>
        )}
      </div>

      {/* Stats */}
      <div style={styles.stats}>
        Total Associates: {groupedAssociates.length}
        {searchTerm && ` (filtered from ${groupedAssociates.length})`}
      </div>



      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          borderTop: "1px solid #E5E7EB",
          background: "#F9FAFB",
        }}
      >
        <div style={{ fontSize: 14, color: "#6B7280" }}>
          Showing {startIndex + 1}–
          {Math.min(startIndex + itemsPerPage, groupedAssociates.length)} of{" "}
          {groupedAssociates.length}
        </div>

        <div style={{ display: "flex", gap: "6px" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background: currentPage === 1 ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .slice(
              Math.max(0, currentPage - 3),
              Math.min(totalPages, currentPage + 2)
            )
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  background:
                    currentPage === page ? "#8b306d" : "#fff",
                  color: currentPage === page ? "#fff" : "#333",
                  cursor: "pointer",
                }}
              >
                {page}
              </button>
            ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background:
                currentPage === totalPages ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};

const styles = {
  input: {
    width: "70%",
    padding: "10px",
    marginTop: "14px",
    borderRadius: "12px",
    border: "1px solid #d1d5db",
    fontSize: "14px"
  },

  dropdown: {
    marginTop: "10px",
    border: "1px solid #d1d5db",
    // padding: "10px",
    borderRadius: "10px",
    cursor: "pointer",
    background: "#fff"
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  },

  modalBox: {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    width: "300px",
    textAlign: "center"
  },

  modalItem: {
    padding: "12px",
    borderBottom: "1px solid #eee",
    cursor: "pointer"
  },

  agentModal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    width: "350px"
  },

  agentList: {
    maxHeight: "250px",
    overflowY: "auto",
    marginTop: "10px"
  },

  agentItem: {
    padding: "10px",
    borderBottom: "1px solid #eee",
    cursor: "pointer"
  },

  closeBtn: {
    marginTop: "15px",
    padding: "8px 14px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    borderRadius: "8px",
    cursor: "pointer"
  }

}